"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextEditorAnt = RichTextEditorAnt;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const RichTextEditor_1 = require("./RichTextEditor");
const RichTextEditorAntOverride = (0, styled_components_1.createGlobalStyle) `
	.ant-form-item-has-error .remirror-editor-wrapper .remirror-editor {
		border: 1px solid ${({ theme }) => theme.color.error};
	}
`;
function RichTextEditorAnt(props) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "rte-ant-wrapper", children: [(0, jsx_runtime_1.jsx)(RichTextEditorAntOverride, {}), (0, jsx_runtime_1.jsx)(RichTextEditor_1.RichTextEditor, { ...props })] }));
}
